import { RootState } from './store';

export const rootSelector = (state: RootState) => state;
